import { render, staticRenderFns } from "./PagesEditor.vue?vue&type=template&id=14e1c5c4&scoped=true"
import script from "./PagesEditor.vue?vue&type=script&lang=js"
export * from "./PagesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e1c5c4",
  null
  
)

export default component.exports